import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { formatPrice } from 'utils/format';

import { Card, Typography } from '../base';

import CloudinaryPicture from './cloudinaryPicture';

const ProductCard = forwardRef((props, ref) => {
  const className = classNames({
    'card-equalize': true,
    'card-product': true,
    [props.className]: props.className,
  });

  let priceLabel = formatPrice(props.product.prices[0], props.product.currency, true);
  if (props.product.prices.length > 1) {
    priceLabel = `Starting at ${priceLabel}`;
  }

  const disabled = props.product.config?.disabled === true

  return (
    <Card ref={ref} {...props} className={className}>
      <div className="card-img-top">
        <CloudinaryPicture prefix={props.imagePrefix} imageKey={props.product.images[0]} style={disabled ? { filter: "grayscale(100%)" } : {}} />
      </div>
      <Card.Body>
        <Typography.H4 className="mb-0">
          <Typography.Span>{props.product.name}</Typography.Span>
        </Typography.H4>
        <Typography.P className="card-text">{disabled ? "Coming Soon" : priceLabel}</Typography.P>
      </Card.Body>
    </Card>
  );
});

ProductCard.propTypes = {
  asLink: PropTypes.bool,
  product: PropTypes.object,
  className: PropTypes.string,
  children: PropTypes.node,
  imagePrefix: PropTypes.string,
};

ProductCard.defaultProps = {
  asLink: false,
  imagePrefix: 'products/',
};

export default ProductCard;
